// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__aM8RG","isTypeView":"styles_isTypeView__UfYZI"};
module.exports.__checksum = "2bb1b6c6288d"
